// layouts/Customization/components/CustomLogicTab.js
import React, { useState } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Icon,
  IconButton,
} from '@mui/material';
import { grey, blue, orange } from '@mui/material/colors';
import CustomLogicDetails from './CustomLogicDetails';

const demoCustomLogic = [
  {
    type: 'apex trigger',
    description: 'quote trigger delegate',
    usedIn: 'Quote processing',
    status: 'Active',
    lines: [
      { name: 'Line 1', description: 'Initial trigger logic' },
      { name: 'Line 2', description: 'Delegate callout' },
    ],
    records: [
      { Name: 'Record 1', Description: 'Trigger execution for new quotes' },
      { Name: 'Record 2', Description: 'Handles quote updates' },
    ],
  },
  {
    type: 'javascript',
    description: 'custom quote calculator',
    usedIn: 'Quote calculation',
    status: 'Inactive',
    lines: [
      { name: 'Line A', description: 'Price calculation function' },
      { name: 'Line B', description: 'Discount application' },
      { name: 'Line C', description: 'Output formatting' },
    ],
    records: [
      { Name: 'Calculation 1', Description: 'Standard pricing calculation' },
      { Name: 'Calculation 2', Description: 'Promotional pricing override' },
      { Name: 'Calculation 3', Description: 'Volume discount logic' },
    ],
  },
];

const typeColorMap = {
  'apex trigger': orange[500],
  javascript: blue[500],
};

function CustomLogicTab() {
  const [selectedCustomLogic, setSelectedCustomLogic] = useState(null);

  const handleViewDetails = (logic) => {
    setSelectedCustomLogic(logic);
  };

  const handleCloseDetails = () => {
    setSelectedCustomLogic(null);
  };

  if (selectedCustomLogic) {
    return <CustomLogicDetails customLogic={selectedCustomLogic} onClose={handleCloseDetails} />;
  }

  return (
    <Card>
      <ArgonBox p={3}>
        <TableContainer component={Paper}>
          <Table aria-label="custom logic table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Description</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Used In</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Status</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {demoCustomLogic.map((logic, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ color: typeColorMap[logic.type] || 'inherit', fontSize: '11pt' }}>
                    {logic.type}
                  </TableCell>
                  <TableCell sx={{ fontSize: '11pt' }}>{logic.description}</TableCell>
                  <TableCell sx={{ fontSize: '11pt' }}>{logic.usedIn}</TableCell>
                  <TableCell sx={{ fontSize: '11pt' }}>{logic.status}</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="info"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleViewDetails(logic)}
                    >
                      View Details
                    </Button>
                    <IconButton color="error" size="small">
                      <Icon>delete</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ArgonBox>
    </Card>
  );
}

export default CustomLogicTab;
